
<template>
  <div>
    <header-group>
    </header-group>
    <div>
      <img src="../assets/1639745877778799.jpg" style="width: 100%; display:block">
    </div>
    <breadcrumb :breadcrumbs=breadcrumbs :button="button">
    </breadcrumb>

    <div class="index-news">
      <div class="index-title">
        <p class="t1" style="color: black;">行业咨询</p>
        <div class="displayF" style="margin-top: 15px">
          <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
        </div>
        <div class="displayF">
        <div class="box">
          <p>游戏采用卡牌战斗的经典方式，还原了动漫中的人物角色性格和搞笑做派。</p>
          <p>&nbsp;</p>
          <p>无论你是否是魔兽玩家？</p>
          <p>&nbsp;</p>
          <p>是否AFK？</p>
          <p>&nbsp;</p>
          <p>都可以在这里和你的朋友在一起战斗，一起下副本，以一种崭新的方式重新体验艾泽拉斯的掌中世界！</p>
        </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import HeaderGroup from "@/components/HeaderGroup.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Bottom from "@/components/Bottom.vue";

export default {
  name: 'content',
  components: {Bottom, Breadcrumb,HeaderGroup},
  data() {
    return {
      breadcrumbs: [{name:'首页',path:'/'},{name:'公司简介',path:'/content'}],
      button:[{name:'最强猎手',url:'/content'},{name:'联系我们',url:'/about'}]
    }
  }


}

</script>
<style scoped>

.index-news {
  padding: 10px 0 70px 0;
  background: white;
}
.index-title {
  padding: 60px 0;
  text-align: center;
  align-items: center;
  position: relative;
  line-height: 30px;
}
.box {
  color: #333;
  margin-top: 20px;
  text-align: justify;
  line-height: 30px;
  font-size: 16px
}
.displayF {
  display: flex;
  justify-content: center;
}

.t1 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px
}

</style>